import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProcessExecutorBackendMockService } from './process-executor-backend.service.mock.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [],
  providers: [ProcessExecutorBackendMockService],
  exports: []
})
export class ProcessExecutorBackendMockModule {
  constructor(private service: ProcessExecutorBackendMockService) { }
  static forRoot(): ModuleWithProviders<ProcessExecutorBackendMockModule> {
    return {
      ngModule: ProcessExecutorBackendMockModule,
      providers: [ProcessExecutorBackendMockService]
    };
  }



}
